// @ts-ignore
import * as defaultText from '../../../assets/languages/en/text.json';
import { LANGUAGES } from "./language.config";
import { COUNTRIES_SHORT } from "../../config/countries.config";
import { BehaviorSubject } from "rxjs";
import * as i0 from "@angular/core";
var LanguageService = /** @class */ (function () {
    function LanguageService() {
        this.activeLanguageKey = 'activeLanguage';
        this.defaultLanguage = LANGUAGES.english;
        this.defaultLanguageText = defaultText['default'];
        this.activeLanguage = new BehaviorSubject(LANGUAGES.english);
        this.activeLanguageText = null;
        this.mexicoDomain = '192.168.0.101';
        //this.detectLanguage();
    }
    LanguageService.prototype.detectLanguage = function () {
        localStorage.setItem('country', COUNTRIES_SHORT.usa);
        if (this.activeLanguage.value === LANGUAGES.spanish) {
            localStorage.setItem('country', COUNTRIES_SHORT.mexico);
        }
        this.getLanguageText(this.activeLanguage.value);
    };
    LanguageService.prototype.setActiveLanguage = function (lang) {
        var newLang = lang ? lang : this.defaultLanguage;
        this.activeLanguage.next(newLang);
        localStorage.setItem(this.activeLanguageKey, newLang);
        this.detectLanguage();
    };
    LanguageService.prototype.getActiveLanguage = function () {
        return String(localStorage.getItem(this.activeLanguageKey));
    };
    LanguageService.prototype.removeActiveLanguage = function () {
        this.activeLanguage.next(this.defaultLanguage);
        this.getLanguageText(this.activeLanguage.value);
        localStorage.removeItem(this.activeLanguageKey);
    };
    LanguageService.prototype.getLanguageText = function (lang) {
        var _this = this;
        var rawFile = new XMLHttpRequest();
        rawFile.open("GET", "./assets/languages/" + lang + "/text.json", false);
        rawFile.onreadystatechange = function () {
            if (rawFile.readyState === 4) {
                if (rawFile.status === 200 || rawFile.status == 0) {
                    _this.activeLanguageText = JSON.parse(rawFile.responseText);
                    console.log('lang', _this.activeLanguage);
                }
            }
        };
        rawFile.send(null);
    };
    LanguageService.prototype.getString = function (value, innerVal) {
        if (this.activeLanguageText && this.activeLanguageText[value]) {
            if (innerVal) {
                if (this.activeLanguageText[value][innerVal]) {
                    return this.activeLanguageText[value][innerVal];
                }
                else {
                    return this.defaultLanguageText[value][innerVal];
                }
            }
            else {
                return this.activeLanguageText[value];
            }
        }
        if (innerVal) {
            return this.defaultLanguageText[value][innerVal];
        }
        return this.defaultLanguageText[value];
    };
    LanguageService.prototype.replaceVariables = function (string, vars) {
        vars.forEach(function (variable) {
            string = string.replace("{{" + Object.keys(variable)[0] + "}}", variable[Object.keys(variable)[0]]);
        });
        return string;
    };
    LanguageService.prototype.getStringWithVariables = function (vars, value, innerVal) {
        var string = this.getString(value, innerVal);
        return this.replaceVariables(string, vars);
    };
    LanguageService.prototype.getStringFirstCharCapital = function (value, innerVal) {
        var str = this.getString(value, innerVal);
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    LanguageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(); }, token: LanguageService, providedIn: "root" });
    return LanguageService;
}());
export { LanguageService };
